export default {"src":"/assets/turbo/ef70a3d2/jelmolich/_next/static/media/favicon.0f48b3ee.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};